import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";
import { TComplain } from "apis/meeting-room-complain";

type ComplainRowProps = {
  complain: TComplain;
  checkedComplainList?: TComplain[];
  onHandleCheck?: () => void;
};
const ComplainRow = ({ onHandleCheck, checkedComplainList = [], complain }: ComplainRowProps) => {
  function formatDate(isoDateStr: string): string {
    const date = new Date(isoDateStr);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  return (
    <Row onClick={onHandleCheck}>
      <RowItem minWidth={24} maxWidth={24}>
        <UI.CheckBox size="medium" onChange={onHandleCheck} selected={checkedComplainList.includes(complain)} />
      </RowItem>
      {complain.isResolved && (
        <RowItem minWidth={160} maxWidth={200}>
          <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
            {formatDate(complain.resolvedAt ?? "") ?? new Date().toString()}
          </UI.Typography>
        </RowItem>
      )}
      <RowItem minWidth={160} maxWidth={200}>
        <UI.Typography type="label01" fontStyle="regular" color="var(--alias-color-label-normal)">
          {formatDate(complain.createdAt ?? "") ?? new Date().toString()}
        </UI.Typography>
      </RowItem>
      <RowItem minWidth={160} maxWidth={200}>
        <UI.Typography
          type="label01"
          fontStyle="regular"
          color="var(--alias-color-label-normal)"
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {complain.meetingRoomName ?? "-"}
        </UI.Typography>
      </RowItem>
      <RowItem minWidth={160} maxWidth={200}>
        <UI.Typography
          type="label01"
          fontStyle="medium"
          color="var(--alias-color-label-normal)"
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {complain.complainCategory ?? "-"}
        </UI.Typography>
      </RowItem>
      <RowItem minWidth={240}>
        <UI.Typography
          type="label01"
          fontStyle="regular"
          color="var(--alias-color-label-normal)"
          style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
        >
          {complain.complainDetail ?? "-"}
        </UI.Typography>
      </RowItem>
    </Row>
  );
};

export default ComplainRow;

const Row = styled.div`
  box-sizing: border-box;
  padding: 12px 24px;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 32px;
  min-width: 1100px;

  border-bottom: 1px solid var(--alias-color-line-normal);
  cursor: pointer;
`;

const RowItem = styled.div<{ minWidth?: number; maxWidth?: number }>`
  min-width: ${(props) => props.minWidth}px;
  max-width: ${(props) => props.maxWidth}px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
